import { NavigationService } from './../../services/navigation.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ProjetoPermission } from '../../models/projeto-permission.model';
import { ProjetoAgregadorService } from '../../services/projeto-agregador.service';
import { BottomSheetComponent } from '../bottom-sheet/bottom-sheet.component';

@Component({
  selector: 'app-agregador-layout',
  templateUrl: './agregador-layout.component.html',
  styleUrls: ['./agregador-layout.component.scss']
})
export class AgregadorLayoutComponent  extends BaseListComponent<ProjetoCadastro> implements OnInit, OnDestroy {

  idProjeto: number;
  projeto: any;
  pathRoute: string;
  menu: any[];
  permissions: ProjetoPermission;

  constructor(
    private router: Router,
    private storage: StorageService,
    private myService: ProjetoAgregadorService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService,
    private _bottomSheet: MatBottomSheet,
  ) {
    super()
  }

  ngOnInit(): void {
    this.initLayout();
    this.addSub(EventSharedService.get('reloadLayout').subscribe((component) => {
      this.loading();
      this.addSub(
        this.myService.getById(this.idProjeto, true).subscribe(
          (res) => {
            this.projeto = res;
            this.onActivate(component);
            this.loaded();
          },
          (error) => {
            this.loaded();
            this.msgError(error.error.message);
            this.navigation.replace(['projetos', 'programa']);
          },
        )
      );
    }));
  }

  initLayout() {
    this.loading();
    this.idProjeto = this.activatedRoute.snapshot.params?.idProjeto;
    this.projeto = this.activatedRoute.snapshot.data['projeto'];
    if (!this.projeto.permissions.edit_check) {
      this.msgError('Você não possui permissão para visualizar este projeto!');
      this.navigation.back([`projetos/agregador`]);
    }
    this.initMenu();
    this.loaded();
  }


  initMenu(path = null) {
    this.pathRoute = path ? path : "/projetos/agregador/" + this.idProjeto + '/';
    this.menu = [
      {
        label: "Cadastro Projeto Agregador",
        rota: "cadastro",
        active: true,
      },
      {
        label: "Projetos",
        rota: "projetos",
        active: true,
      },
      {
        label: "Indicadores",
        rota: "indicadores",
        active: true,
      }
    ]
  }

  isActive(route: string): boolean {
    return this.router.routerState.snapshot.url.replace('/projetos/agregador/', '').includes(route);
  }

  ngOnDestroy(): void {
    this.storage.removeIdProjeto();
    this.unsubscribeList();
  }

  onActivate(component) {
    component.idProjeto = this.idProjeto;
    component.projeto = this.projeto;
  }

  openBottomSheet(): void {
    this._bottomSheet.open(BottomSheetComponent, { data: { pathRoute: this.pathRoute, menu: this.menu, type: 'agregador' } });
  }
}
